import styled from "styled-components";

export const CurtainRaiserContainer = styled.div<{ show: boolean }>(({ show }) => {
    return {
        position: "absolute",
        zIndex: 999,

        opacity: show ? 1 : 0,
        visibility: show ? "visible" : "hidden",
        transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",

        "@supports (top: var(--sat))": {
            top: "calc(var(--sat) * -1)",
        },
    };
});

export const ErrorContainer = styled.div`
    width: 100vw;
    height: 100vh;
    background: ${({ theme }) => theme.colors[theme.colorMode].canvas_Primary};
    z-index: 999;
    position: absolute;
`;
